import { ChatRepository } from 'application/repositories/ChatRepository';
import {
    AttachmentQuery,
    ChatHistoryQuery,
    FileUploadPayload,
    MessageStatusPayload,
    MessageUploadPayload,
} from 'domain/entities/ChatEntity';
import axiosConfig from 'infrastructure/config/axios';

export class ChatAPI implements ChatRepository {
    async getChatRoom(): Promise<any> {
        const API_URL = `/chat/chat-room`;
        const response = await axiosConfig.getAxiosConfig().get(API_URL);
        return response.data;
    }

    async getChatHistory(query: ChatHistoryQuery): Promise<any> {
        const params = new URLSearchParams({
            chatRoomId: query.chatRoomId.toString(),
            page: query.page.toString(),
            pageSize: query.pageSize.toString(),
        });
        const API_URL = `/chat/chat-history?` + params.toString();
        const response = await axiosConfig.getAxiosConfig().get(API_URL);
        return response.data;
    }

    async getUnreadMessage(): Promise<any> {
        const API_URL = `/chat/unread-message`;
        const response = await axiosConfig.getAxiosConfig().get(API_URL);
        return response.data;
    }

    async postMessage(payload: MessageUploadPayload): Promise<any> {
        const API_URL = `/chat/store-message`;
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }

    async postMessageStatus(payload: MessageStatusPayload): Promise<any> {
        const API_URL = `/chat/update-message-status`;
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }

    async postUploadFile(payload: FileUploadPayload): Promise<any> {
        const API_URL = `/chat/upload-file`;
        const formData = new FormData();
        formData.append('file', payload.file);
        formData.append('chatRoomId', payload.chatRoomId.toString());
        const response = await axiosConfig.getAxiosConfig().post(API_URL, formData);
        return response.data;
    }

    async getAttachmentFile(query: AttachmentQuery): Promise<any> {
        const params = new URLSearchParams({
            chatRoomId: query.chatRoomId.toString(),
        });
        const API_URL = `/chat/attachment-file?` + params.toString();
        const response = await axiosConfig.getAxiosConfig().get(API_URL);
        return response.data;
    }

    async updateChatSetting(): Promise<any> {
        const API_URL = `/chat/change-setting-notice`;
        const response = await axiosConfig.getAxiosConfig().put(API_URL);
        return response.data;
    }
}
